import React, { Component } from "react";
import { string, number, object, oneOfType } from "prop-types";

export class Icon extends Component {
  static propTypes = {
    name: string,
    size: number,
    className: oneOfType([string, object]),
    fill: string,
    text: string,
  };

  render() {
    const { name, size = 20, fill, className, text } = this.props;
    return (
      <>
        <svg
          className={`icon ${className || ""}`}
          style={{
            width: `${size}px`,
            height: `${size}px`,
            fill: fill || "currentColor",
            verticalAlign: "middle",
            display: "inline-block",
          }}
        >
          <use href={`#${name}`} xlinkHref={`#${name}`} />
        </svg>
        {text && <span style={{ margin: "9px" }}>{text}</span>}
      </>
    );
  }
}
